
import { fetchAuthSession } from 'aws-amplify/auth';
import { BedrockRuntimeClient, InvokeModelCommand } from '@aws-sdk/client-bedrock-runtime';

const GenerateCohesiveImage = async (setImages, promptSeed, style) => {
    const session = await fetchAuthSession()
    // console.log(session)
    // console.log(context)

    // const bedrockClient = new BedrockRuntimeClient({
    //     region: 'us-east-1',
    //     credentials: session.credentials
    // });
    // const modelId = "amazon.titan-image-generator-v2:0";
    // Toggle Between Stability and Titan
    const bedrockClient = new BedrockRuntimeClient({
        region: 'us-east-1',
        credentials: session.credentials
    });
    const modelId = "amazon.nova-canvas-v1:0"; //"stability.sd3-large-v1:0"; //"stability.stable-diffusion-xl-v1"//

    const prompt = "In a " + style + " style depict " + promptSeed
    // console.log(prompt)
    // console.log(prompt.slice(0, 1024))
    const nativeRequest = {
        textToImageParams: { text: prompt.substring(0, 1024) },
        taskType: "TEXT_IMAGE",
        imageGenerationConfig: {
            cfgScale: 8,
            seed: 12,
            width: 1024,
            height: 1024,
            numberOfImages: 3
        }
    };

    // const nativeRequest = {
    //     prompt: prompt,
    //     mode: "text-to-image",
    //     output_format: "jpeg"
    // };

    const body = new TextEncoder().encode(JSON.stringify(nativeRequest));

    const input = {
        body: body, // Required
        contentType: "application/json",
        accept: "application/json",
        modelId: modelId, // Required
        trace: "ENABLED"
    };

    const command = new InvokeModelCommand(input);

    try {
        const response = await bedrockClient.send(command);
        const modelResponse = JSON.parse(new TextDecoder().decode(response.body));
        const base64ImageData = modelResponse.images;

        // console.log("response received")
        setImages(base64ImageData.map((value, key) => `data:image/png;base64,${value}`));
        // Set the image source to display the image in the component
        return `data:image/png;base64,${base64ImageData}`;
    } catch (error) {
        console.error('Error generating image:', error);
    }
};

export default GenerateCohesiveImage;